import React, { useState, useContext, useCallback, useEffect} from "react";
import { RootContext } from "../../../contexts/root-context";
import { useNavigate } from "react-router-dom";
import { Auth } from 'aws-amplify';
import changePasswordData from './change-password.json'
import { validateJson, isJsonValid } from '../../../util';
const ChangePassword = () => {
  const navigate = useNavigate();
  
  const { authDetails, setisnotify } = useContext(RootContext);
  const [state, setState] = useState({
    password: "",
    newpassword: "",
    comfirmpassword: "",
    error: undefined,
  });
  const [formValues, setFormValues] = useState({
    password: "",
    newpassword: "",
    comfirmpassword: "",
    error: ""
  });


  const validateChangePasswordData=useCallback(()=>{
    const jsonString = JSON.stringify( changePasswordData); 
     
    if (isJsonValid(jsonString)) {
      validateJson( changePasswordData,changePasswordData.changePasswordSchema); 
    } else {
      
      console.error('Invalid JSON syntax: Missing braces or commas.');
    }
  }, [changePasswordData]);


useEffect(() => {
    validateChangePasswordData();

}, [validateChangePasswordData]);


  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.id]: e.target.value
    })
    setFormValues({ ...formValues, [e.target.id]: e.target.value });
  }

  const [formErrors, setFormErrors] = useState({});
  async function handleSubmit(event) {
    event.preventDefault();
    const errors = {};
    if (!formValues.password) {
      errors.password = changePasswordData.errors.currentpass;
    }
    if (!formValues.password || authDetails.password !== event.target.password.value) {
      errors.password = changePasswordData.errors.validpass;
    }
    if (!formValues.newpassword) {
      errors.newpassword = changePasswordData.errors.newpass;
    }

    if (formValues.newpassword.length < 6) {
      errors.newpassword =changePasswordData.errors.passwordlength;
    }
    if (formValues.newpassword !== formValues.comfirmpassword) {
      errors.comfirmpassword =changePasswordData.errors.reEntredPass;
    }
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      const user = await Auth.signIn(authDetails.uname, authDetails.password);
      await Auth.completeNewPassword(user, formValues.comfirmpassword);
      await Auth.signOut();
      navigate('../')
      setisnotify(changePasswordData.errors.updatepass);
    }
  }
  return (
    <div className="ABB_CommonUX_LoginScreen__root ABB_CommonUX_LoginScreen__light login-container">

      <div className="ABB_CommonUX_LoginScreen__header">
        <div />
        <div className="ABB_CommonUX_LoginScreen__logo" />
      </div>
      <div className="ABB_CommonUX_LoginScreen__contentWrapper">

        <div className="ABB_CommonUX_LoginScreen__content">
          <form onSubmit={handleSubmit}  >
            <h1 className="ABB_CommonUX_LoginScreen__productName">{changePasswordData.labels.changeYourPass}</h1>
            <div className="ABB_CommonUX_LoginScreen__form">
              <div className="ABB_CommonUX_LoginScreen__formRow">
                <div className="ABB_CommonUX_LoginScreen__customContent">
                  <div />
                </div>
              </div>
              <div className="ABB_CommonUX_LoginScreen__formRow">
                <div className="ABB_CommonUX_LoginScreen__password">
                  <div className="ABB_CommonUX_Input__root ABB_CommonUX_Input__light ABB_CommonUX_Input__normal ABB_CommonUX_Input__isValid ABB_CommonUX_Input__isEmpty">
                    <div className="ABB_CommonUX_Input__labelContainer">
                      <span className="ABB_CommonUX_Input__label"><b>{changePasswordData.labels.currentPassword}</b></span>
                    </div>
                    <div className="ABB_CommonUX_Input__inputWrapper ABB_CommonUX_Input__hasFixedSize">
                      <input
                        className="ABB_CommonUX_Input__inputElement"
                        type="password"

                        required
                        name="password"
                        id="password"
                        onKeyUpCapture={handleChange}
                      />
                      <span className="ABB_CommonUX_Input__iconWrapper">
                        <i className="ABB_CommonUX_Icon__root">
                          <i className="ABB_CommonUX_Icon__icon_abb_16 ABB_CommonUX_Icon-16-style__icon-abb_user_16" />
                        </i>
                      </span>

                    </div>
                  </div>
                  {formErrors.password && <span className="error-display">{formErrors.password}</span>}

                </div>
                <div>
                  <div className="ABB_CommonUX_Input__root ABB_CommonUX_Input__light ABB_CommonUX_Input__normal ABB_CommonUX_Input__isValid ABB_CommonUX_Input__isEmpty">
                    <div className="ABB_CommonUX_Input__labelContainer">
                      <span className="ABB_CommonUX_Input__label"><b>{changePasswordData.labels.newPassword}</b></span>
                    </div>
                    <div className="ABB_CommonUX_Input__inputWrapper ABB_CommonUX_Input__hasFixedSize">
                      <input
                        className="ABB_CommonUX_Input__inputElement"
                        type="password"

                        defaultValue=""
                        required
                        name="newpassword"
                        id="newpassword"
                        onKeyUpCapture={handleChange}
                      />
                      <span className="ABB_CommonUX_Input__iconWrapper">
                        <i className="ABB_CommonUX_Icon__root">
                          <i className="ABB_CommonUX_Icon__icon_abb_16 ABB_CommonUX_Icon-16-style__icon-abb_lock-closed_16" />
                        </i>
                      </span>

                    </div>
                  </div>
                  {formErrors.newpassword && <span className="error-display">{formErrors.newpassword}</span>}
                </div>
                <div className="ABB_CommonUX_LoginScreen__password">
                  <div className="ABB_CommonUX_Input__root ABB_CommonUX_Input__light ABB_CommonUX_Input__normal ABB_CommonUX_Input__isValid ABB_CommonUX_Input__isEmpty">
                    <div className="ABB_CommonUX_Input__labelContainer">
                      <span className="ABB_CommonUX_Input__label"><b>{changePasswordData.labels.reEnterPass}</b></span>
                    </div>
                    <div className="ABB_CommonUX_Input__inputWrapper ABB_CommonUX_Input__hasFixedSize">
                      <input
                        className="ABB_CommonUX_Input__inputElement"
                        type="password"

                        defaultValue=""
                        required
                        name="comfirmpassword"
                        id="comfirmpassword"
                        onKeyUpCapture={handleChange}
                      />
                      <span className="ABB_CommonUX_Input__iconWrapper">
                        <i className="ABB_CommonUX_Icon__root">
                          <i className="ABB_CommonUX_Icon__icon_abb_16 ABB_CommonUX_Icon-16-style__icon-abb_lock-closed_16" />
                        </i>
                      </span>

                    </div>
                  </div>
                  {formErrors.comfirmpassword && <span className="error-display">{formErrors.comfirmpassword}</span>}

                </div>
              </div>

            </div>
            <br></br>
            <div className="ABB_CommonUX_LoginScreen__bottom">
              <div className="ABB_CommonUX_LoginScreen__buttons ABB_CommonUX_LoginScreen__flexSpring">
                <div className="ABB_CommonUX_LoginScreen__button">
                  <button className="ABB_CommonUX_Button__root ABB_CommonUX_Button__primaryblack ABB_CommonUX_Button__mediumSize ABB_CommonUX_Button__light ABB_CommonUX_Button__rounded" id="update-password">
                    <div>
                      <span className="ABB_CommonUX_Button__text ABB_CommonUX_Button__hasText">
                        {changePasswordData.labels.updateMsg} &nbsp;
                      </span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

      </div>


    </div>

  );
};

export default ChangePassword;
